export const STEPS = {
    PRODUCT_SELECTION: 'PRODUCT_SELECTION',
    CHECKOUT: 'CHECKOUT',
    PAYMENT_SELECTION: 'PAYMENT_SELECTION',
};
